import { render, staticRenderFns } from "./PurchasePrincipleDetail.vue?vue&type=template&id=72176a62&scoped=true"
import script from "./PurchasePrincipleDetail.vue?vue&type=script&lang=js"
export * from "./PurchasePrincipleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72176a62",
  null
  
)

export default component.exports